import React from 'react';
import Navbar from '../Navbar/Navbar';
import Footer from '../Footer/Footer';
import './DanismaKurulu.css';

function DanismaKurulu() {
  const danismaListesi = [
    { ad: "Prof. Dr. Ayşegül Asuman AKDOĞAN", kurum: "	Erciyes Üniversitesi" },
    { ad: "Prof. Dr. Mehmet BARCA", kurum: "Ankara Sosyal Bilimler Üniversitesi" },
    { ad: "Prof. Dr. Tülay İLHAN NAS ", kurum: "Karadeniz Teknik Üniversitesi" },
    { ad: "Prof. Dr. Mahmut PAKSOY ", kurum: "İstanbul Kültür Üniversitesi" },
    { ad: "Prof. Dr. Ömür N. TİMURCANDAY ÖZMEN ", kurum: "Dokuz Eylül Üniversitesi" },
    { ad: "Prof. Dr. Vala Lale TÜZÜNER ", kurum: "İstanbul Üniversitesi" },
    { ad: "Prof. Dr. Kadir VAROĞLU ", kurum: "Başkent Üniversitesi" },
    { ad: "Prof. Dr. Nazlı WASTİ PAMUKSUZ ", kurum: "Orta Doğu Teknik Üniversitesi" },
    { ad: "Prof. Dr. Uğur YOZGAT ", kurum: "İstanbul Nişantaşı Üniversitesi" },

  ];

  return (
    <div className="danisma-page">
      <Navbar />
      
      <header className="page-hero">
        <div className="container">
          <h2>Danışma Kurulu</h2>
          <p>Ulusal Yönetim ve Organizasyon Kongresi Akademik Rehberleri</p>
        </div>
      </header>

      <main className="content-container">
        <div className="danisma-list">
          {danismaListesi.map((hoca, index) => (
            <div key={index} className="hoca-item">
              <div className="hoca-info">
                <span className="hoca-name">{hoca.ad}</span>
                <span className="hoca-uni">{hoca.kurum}</span>
              </div>
            </div>
          ))}
        </div>
      </main>

      <Footer />
    </div>
  );
}

export default DanismaKurulu;